meetingTestrtc.directive('meetingTestrtc', [
    'templateCache',
    'helperService',
    function (templateCache, helperService) {
        return {
            restrict: 'E',
            template: templateCache.getTemplate(helperService.getRedesignPathPrefix() + 'meeting-testrtc.html')
        };
    }
]);
